import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const open = 1;

export const TwoColumnDataDisplayRow = memo(({ title, value, unit, openStatusFlag}) => {
    return (
        <Row>
            <LeftSpan>{title}: </LeftSpan>
            <RightSpan openStatusFlag={openStatusFlag}>{value}{unit}</RightSpan>
        </Row>
    );
});

TwoColumnDataDisplayRow.displayName = 'TwoColumnDataDisplayRow';
TwoColumnDataDisplayRow.propTypes = {
    title: PropTypes.string,
    value: PropTypes.any,
    unit: PropTypes.string,
    openStatusFlag: PropTypes.number,
};

const Row = styled.div`
    white-space: nowrap;
    width: 100%;
`;

const LeftSpan = styled.span`
    display: inline-block;
    color: #6F6F6F;
    width: 50%;
    margin-bottom: 7px;
`;

const RightSpan = styled.span`
    display: inline-block;
    width: 48%;
    margin-bottom: 7px;
    color: ${({ openStatusFlag }) => {
        if (openStatusFlag === open) {
            return 'forestgreen';
        } else if (openStatusFlag > open) {
            return 'firebrick';
        } else {
            return 'black';
        }
    }};
`;
